import { HTTP } from "@/utils/http-common"

export default {
  get: function ($, nonConformityId, pictureId = null) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/projects/non-conformities/${pictureId ? pictureId : nonConformityId}/pictures`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  create: function ($, nonConformityId, pictures) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/projects/non-conformities/${nonConformityId}/pictures`, pictures)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  update: function ($, id, picture) {
    return new Promise((resolve, reject) => {
      HTTP.patch(`/projects/pictures/${id}`, picture)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  remove: function ($, id) {
    return new Promise((resolve, reject) => {
      HTTP.delete(`/projects/pictures/${id}`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  getPicture: function ($, id) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/projects/pictures/${id}`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  getPictures: function () {
    return new Promise((resolve, reject) => {
      HTTP.get(`/projects/documents/pictures`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  createPicture: function (pictures) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/projects/documents/pictures`, pictures)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  }
}
